const notice = {
    id: 'notice',
    title: '공지사항',
    url: '/notice',
    children: [] // RootLayout과의 호환성을 위해 빈 배열 유지
};

const admin = {
    id: 'admin',
    title: "Admin",
    children: [
        {
            id: 'vendor',
            title: '공급처정보 관리',
            url: '/vendor'
        },
        {
            id: 'user',
            title: '사용자정보 관리',
            url: '/user',
        },
        {
            id: 'itemcode',
            title: '품목정보 관리',
            url: '/itemCode',
        },
        {
            id: 'wacode',
            title: '공급처별 공정관리',
            url: '/workAreaCode',
        },
        {
            id: 'vendoritem',
            title: '품목정보 연동',
            url: '/itemCodePerVendor',
        },        
        {
            id: 'inspectitem',
            title: '품목별 검사항목 등록',
            url: '/inspectItem',
        },
        
    ]
};

const vendor = {
    
    id : 'inspection',
    title : 'Inspection',
    children: [
        {
            id: 'controlChart',
            title: 'Control Chart',
            url: '/trendChart',
        },
        {
            id: 'iqc',
            title: 'IQC 검사등록',
            url: '/iqc',
        },
        {
            id: 'iqcList',
            title: 'IQC 검사조회',
            url: '/iqclist',
        },
        // {
        //     id: 'pqc',
        //     title: 'PQC 검사등록',
        //     url: '/pqc',
        // },
        // {
        //     id: 'pqcList',
        //     title: 'PQC 검사조회',
        //     url: '/pqc_list',
        // },
        {
            id: 'oqc',
            title: 'OQC 검사등록',
            url: '/oqc',
        },
        {
            id: 'oqcList',
            title: 'OQC 검사조회',
            url: '/oqclist',
        },
        {
            id: 'inspReport',
            title: '검사결과 현황',
            url: '/inspReport',
        },
    ]
};

const management = {
    id : 'supplierMgmt',
    title : '협력사 관리',
    children: [
        {
            id: 'certMgmt',
            title: '협력사 인증 관리',
            url: '/certMgmt', 
        },
        {
            id: 'auditStatus',
            title: '협력사 Audit 현황',
            url: '/auditStatus', 
        },
        {
            id: 'correctiveAction',
            title: '협력사 Audit 시정조치',
            url: '/correctiveAction', 
        },
        {
            id: 'PcnMgmt',
            title: '협력사 변경점 관리',
            url: '/pcnMgmt', 
        },
        {
            id: 'NcrMgmt',
            title: '협력사 부적합 관리',
            url: '/ncrMgmt', 
        },
    ]
};


export { notice, admin, vendor, management};